import { render } from "./navBar.vue?vue&type=template&id=011bd7e3&scoped=true"
import script from "./navBar.vue?vue&type=script&lang=js"
export * from "./navBar.vue?vue&type=script&lang=js"

import "./navBar.vue?vue&type=style&index=0&id=011bd7e3&lang=scss&scoped=true"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011bd7e3"]])

export default __exports__